'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Block = require('ipfs-block');

var CID = require('cids');

var multihash = require('multihashes');

var configure = require('../lib/configure');

var toFormData = require('../lib/buffer-to-form-data');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;

  function put(_x, _x2) {
    return _put.apply(this, arguments);
  }

  function _put() {
    _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, options) {
      var _multihash$decode, name, length, cid, _multihash$decode2, _name, _length, searchParams, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};

              if (Block.isBlock(data)) {
                _multihash$decode = multihash.decode(data.cid.multihash), name = _multihash$decode.name, length = _multihash$decode.length;
                options = _objectSpread(_objectSpread({}, options), {}, {
                  format: data.cid.codec,
                  mhtype: name,
                  mhlen: length,
                  version: data.cid.version
                });
                data = data.data;
              } else if (options.cid) {
                cid = new CID(options.cid);
                _multihash$decode2 = multihash.decode(cid.multihash), _name = _multihash$decode2.name, _length = _multihash$decode2.length;
                options = _objectSpread(_objectSpread({}, options), {}, {
                  format: cid.codec,
                  mhtype: _name,
                  mhlen: _length,
                  version: cid.version
                });
                delete options.cid;
              }

              searchParams = new URLSearchParams(options.searchParams);
              if (options.format) searchParams.set('format', options.format);
              if (options.mhtype) searchParams.set('mhtype', options.mhtype);
              if (options.mhlen) searchParams.set('mhlen', options.mhlen);
              if (options.pin != null) searchParams.set('pin', options.pin);
              if (options.version != null) searchParams.set('version', options.version);
              _context.prev = 8;
              _context.next = 11;
              return ky.post('block/put', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: searchParams,
                body: toFormData(data)
              }).json();

            case 11:
              res = _context.sent;
              _context.next = 23;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](8);

              if (!(options.format === 'dag-pb')) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return", put(data, _objectSpread(_objectSpread({}, options), {}, {
                format: 'protobuf'
              })));

            case 20:
              if (!(options.format === 'dag-cbor')) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return", put(data, _objectSpread(_objectSpread({}, options), {}, {
                format: 'cbor'
              })));

            case 22:
              throw _context.t0;

            case 23:
              return _context.abrupt("return", new Block(data, new CID(res.Key)));

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 14]]);
    }));
    return _put.apply(this, arguments);
  }

  return put;
});